import React from 'react';
import SectionHeading from '../../Common/SectionHeading';
import Image from 'next/image';

const Solutions = ({title=null}) => {
    const competitorData = {
        competitors: [
            {
                title: 'Conference Coverage',
                description: 'Select, plan, track and assess relevant assets/companies and their updates through targeted pre-, peri- and post-conference coverage',
                imageSrc: 'img/primary-research/Conference-Coverage-01.svg',
            },
            {
                title: 'Expert/KOL Interviews',
                description: 'Gather opinions from Thought Leaders & Experts on a choice of Key Intelligence Topics (KITs) or Key Intelligence Questions (KIQs)',
                imageSrc: 'img/primary-research/Expert-KOL-Interviews-01.svg',
            },
            {
                title: 'Competitor Tracking',
                description: 'Providing milestone insights gathered from Industry Experts to strategize clinical or commercial development',
                imageSrc: 'img/primary-research/Competitor-Tracking-01.svg',
            },
            {
                title: 'Clinical Trial Monitoring',
                description: 'Keep track of clinical outcomes, trial results and development (phase changes, enrolment status), and new data of key trials of interest',
                imageSrc: 'img/primary-research/Clinical-Trial-Monitoring-01.svg',
            },
            
            {
                title: 'Social Media Monitoring',
                description: 'Monitor sentiment and gauge the pulse of the latest trends on any treatment modalities via our proprietary methodology',
                imageSrc: 'img/primary-research/Social-Media-Monitoring-01.svg',
            },
            {
                title: 'Price Setting Survey',
                description: 'Know the perception of Pricing and Reimbursement experts of therapies and treatments across countries',
                imageSrc: 'img/primary-research/Price-Setting-Survey-01.svg',
            },
        ],
    };
    
    // Separate the competitors into two groups, top and bottom
    const topCompetitors = competitorData.competitors.slice(0, 2);
    const bottomCompetitors = competitorData.competitors.slice(2);
    
    return (
        <>
            <div className="my-12">
                <div className="w-11/12 xl:max-w-screen max-w-screen-2xl mx-auto lg:my-8 my-4">
                    <div className="grid grid-cols-12 gap-6">
                        <div className="lg:col-span-6 col-span-12">
                            <Image 
                                priority={false} 
                                src={process.env.IMG_CDN+'img/primary-research/primary-research.png'}
                                width={2000} 
                                height={2000} 
                                alt="Primary Research" 
                                className="hidden lg:block"
                            />
                        </div>
                        <div className="lg:col-span-6 col-span-12">
                            {(title) &&
                                <SectionHeading title={title}  customClass="text-center"/>
                            }
                            <div className="grid grid-cols-12 gap-6">
                                {topCompetitors.map((competitor, index) => (
                                    <div className="lg:col-span-6 md:col-span-6 col-span-12"  key={index}>
                                        <div className="flex">
                                            <Image 
                                                priority={false} 
                                                style={{marginBottom: 'auto'}} 
                                                className="w-20 h-full pr-2" 
                                                src={process.env.IMG_CDN+competitor.imageSrc} 
                                                width={2000} 
                                                height={2000} 
                                                alt={competitor.title} 
                                            />
                                            <div>
                                                <h3 className="text-lg font-semibold">{competitor.title}</h3>
                                                <p className="text-base">{competitor.description}</p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        
                    </div>

                    <div className="grid grid-cols-12 gap-4"  >
                        {bottomCompetitors.map((competitor, index) => (
                        <div className="lg:col-span-3 md:col-span-6 col-span-12" key={index}>
                            <div className="flex">
                                <Image 
                                    priority={false} 
                                    style={{marginBottom: 'auto'}} 
                                    className="w-20 h-full pr-2" 
                                    src={process.env.IMG_CDN+competitor.imageSrc} 
                                    width={2000} 
                                    height={2000} 
                                    alt={competitor.title} 
                                />
                                <div>
                                    <h3 className="text-lg font-semibold">{competitor.title}</h3>
                                    <p className="text-base">{competitor.description}</p>
                                </div>
                            </div>
                        </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    )
}
export default Solutions;
